import type { ProductBadgeType } from 'src/components/atoms/ProductBadge/ProductBadge';
import type { ProductState } from 'src/redux/product/types';

// Ordered by priority: the first rule that applies wins.
const BADGE_RULES: { applies: (product: ProductState) => boolean; badge: ProductBadgeType }[] = [
  {
    applies: (product) => !product.available && product.availability === 'suspended',
    badge: 'unavailable',
  },
  { applies: (product) => !product.purchasable, badge: 'outOfStock' },
  { applies: (product) => product.isNew, badge: 'new' },
  { applies: (product) => Boolean(product.attributes?.highlyRated), badge: 'mostLoved' },
];

export const getProductBadge = (product: ProductState): ProductBadgeType | undefined =>
  BADGE_RULES.find(({ applies }) => applies(product))?.badge;
